<template>
  <button
    @click="emit('close')"
    type="button"
    class="sticky top-4 right-4 sm:top-6 sm:right-6 flex text-gray-700 bg-gray-100 transition-animation hover:bg-gray-200 hover:text-gray-900 rounded-full text-sm w-8 h-8 ml-auto justify-center items-center z-50"
  >
    <svg
      class="w-3 h-3"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
      />
    </svg>
    <span class="sr-only">Close modal</span>
  </button>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  (e: 'close'): void
}>()
</script>

<style scoped></style>
